export class AuthModel {
  accessToken: string;
  refreshToken: string;
  expires: number;
  id: string;

  setAuth(auth: any) {
    this.accessToken = auth.accessToken;
    this.refreshToken = auth.refreshToken;
    this.expires = auth.expires;
    this.id = auth.id;
  }
}

export class SsoResponseModel {
  accessToken: string;
  idToken: string;
  expires: number;
  refreshToken: string;

  setSso(sso: any){
    this.accessToken = sso.accessToken;
    this.idToken = sso.idToken;
    this.expires = sso.expires;
    this.refreshToken = sso.refreshToken;
  }
}
